import { render, staticRenderFns } from "./Typist.vue?vue&type=template&id=e4c6764e&scoped=true&v-code=true"
import script from "./Typist.vue?vue&type=script&lang=js"
export * from "./Typist.vue?vue&type=script&lang=js"
import style0 from "./Typist.vue?vue&type=style&index=0&id=e4c6764e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c6764e",
  null
  
)

export default component.exports